import gettext from '@sdk/lang/gettext';

import { LoadingTextIndicator } from '@web/components/LoadingTextIndicator/LoadingTextIndicator';

import { useLoadMoreButton } from './loadMoreButton.hooks';

type Props = {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: VoidFunction;
};
export function LoadMoreButton({ hasNextPage, isFetchingNextPage, fetchNextPage }: Props) {
  const { setLoadMoreNode } = useLoadMoreButton(fetchNextPage);

  if (!hasNextPage) {
    return null;
  }

  return (
    <div ref={setLoadMoreNode}>
      {!isFetchingNextPage && (
        <LoadingTextIndicator
          label={gettext('Load more results')}
          onClick={() => fetchNextPage()}
        />
      )}
    </div>
  );
}
